import { WinnerCircle } from "./WinnerCircle";
import { LooserCircle } from "./LooserCircle";

export function renderCursorWithState(args) {
  const { winnerArray, gameEnded, id, timerAnimation, isMobile } = args;

  if (gameEnded === true && winnerArray) {
    const userWithPosition = winnerArray.filter((user) => user.id === id);
    const position = userWithPosition[0] ? userWithPosition[0].position + 1 : null;

    if (position && position === 1) {
      return !isMobile ? (
        <>
          <div className="info_winner">🥇</div>
          <div className="cursor winner">
            <WinnerCircle></WinnerCircle>
          </div>
        </>
      ) : (
        <div>
          <div className="cursor_result">
            <div className="info_winner">🥇</div>
          </div>
        </div>
      );
    } else if (position && position !== 1) {
      return !isMobile ? (
        <>
          <div className="info_looser">{position}</div>
          <div className="cursor looser">
            <LooserCircle finalRank={position}></LooserCircle>
          </div>
        </>
      ) : (
        <div>
          <div className="cursor_result">
            <div className="info_looser">{position}</div>
          </div>
        </div>
      );
    }
  } else if (gameEnded === false && !winnerArray) {
    return (
      <div className={`cursor ${isMobile ? "ownPlayer" : null}`}>
        <div className={timerAnimation ? "point_1 animationRev" : "point_1"}></div>
        <div className={timerAnimation ? "point_2 animation" : "point_2"}></div>
      </div>
    );
  }
}
